import React from 'react'
import IconBase from './IconBase'

const Checkmark = props =>
  <IconBase viewBox="0 0 42.1 42" {...props}>
    <path d="m39.8 1.5c-0.5-0.3-1-0.5-1.5-0.5-0.9 0-1.8 0.5-2.3 1.3l-21.8 31.3-8.4-9.6c-1.1-1.1-2.9-1.1-4 0s-1.1 2.9 0 4l0.1 0.1 10.1 11.5 0.2 0.3 0.3 0.3 0.1 0.1 0.2 0.2 0.5 0.3 0.1 0.1 0.9 0.2c0.8 0 1.5-0.3 2.1-0.9l0.2-0.4 24-34.5c0.9-1.3 0.5-3-0.8-3.8z"/>
    <path d="m14.3 42.1h-0.2l-1.2-0.3-0.2-0.2-0.6-0.4-0.7-0.8-0.2-0.2-10.1-11.5c-1.5-1.5-1.5-3.9 0-5.4s3.9-1.5 5.4 0l7.6 8.7 21.1-30.3c0.6-1 1.8-1.7 3.1-1.7 0.6 0 1.3 0.2 2 0.6 0.9 0.6 1.5 1.4 1.7 2.4s0 2-0.6 2.8l-24 34.4-0.2 0.5-0.1 0.1c-0.8 0.9-1.7 1.3-2.8 1.3zm-0.4-2.1l0.5 0.1c0.4 0 0.8-0.2 1.2-0.5l0.2-0.4 24-34.5c0.3-0.4 0.4-0.8 0.3-1.3-0.1-0.4-0.4-0.8-0.8-1s-0.7-0.4-1-0.4c-0.6 0-1.1 0.3-1.5 0.8l-22.5 32.4-9.3-10.5c-0.7-0.7-1.8-0.7-2.5 0s-0.7 1.9 0 2.6l0.1 0.1 10.8 12.3 0.5 0.3z"/>
  </IconBase>

export default Checkmark
